module.exports = __webpack_public_path__ + "static/img/商用.c8f1302f.png";